import React, { useEffect, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import camelcaseKeys from 'camelcase-keys'

import reserveApi from '../../../utils/axios'

import { AdminHeader } from '../Index'
import { AdminTd, AdminTh, AdminTable } from '../Tables'
import Dropdown from '../../utils/Dropdown'
import DateFormat from '../../utils/dateFormat'

export const Facilities = ({ short, userId = null }) => {
  const [facilities, setFacilities] = useState([])
  const [typeFilter, setTypeFilter] = useState()
  const [agencyFilter, setAgencyFilter] = useState()

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/admin/facilities',
      params: { user_id: userId }
    }).then(response => {
      setFacilities(camelcaseKeys(response.data, { deep: true }))
    })
  }, [userId])

  const types = useMemo(
    () => [...new Set(facilities.map(facility => facility.type))].map(value => ({ option: value, value })),
    [facilities]
  )

  const agencies = useMemo(
    () => [...new Set(facilities.map(facility => facility.agencyName))].map(value => ({ option: value, value })),
    [facilities]
  )

  const filteredFacilities = useMemo(
    () =>
      facilities.filter(
        facility =>
          (!agencyFilter && !typeFilter) ||
          (typeFilter && facility.type === typeFilter.value) ||
          (agencyFilter && facility.agencyName === agencyFilter.value)
      ),
    [facilities, typeFilter, agencyFilter]
  )

  return (
    <div>
      {!short && <AdminHeader>Facilities</AdminHeader>}

      <div className="flex">
        <div className="w-1/4 my-4">
          <Dropdown options={types} onChange={selected => setTypeFilter(selected)} />
        </div>

        <div className="w-1/4 my-4">
          <Dropdown options={agencies} onChange={selected => setAgencyFilter(selected)} />
        </div>
      </div>

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>X</AdminTh>
            <AdminTh>Name</AdminTh>
            <AdminTh>Type / Agency</AdminTh>
            <AdminTh>Last Import</AdminTh>
          </tr>
        </thead>
        {filteredFacilities.map((obj, index) => (
          <tr key={index} className={obj.id && index % 2 !== 0 && 'bg-green-100'}>
            <AdminTd>{obj.arCount}</AdminTd>
            <AdminTd>
              <div>
                <Link to={`/f/${obj.slug}`}>{obj.name}</Link>
              </div>
              <span className="text-sm text-gray-400">{obj.id}</span>
            </AdminTd>

            <AdminTd className="max-w-xs">
              <div className="truncate">{obj.type}</div>
              <div className="truncate">{obj.agencyName}</div>
            </AdminTd>
            <AdminTd>
              <DateFormat date={obj.lastImport} format="l LTS" />
            </AdminTd>
          </tr>
        ))}
      </AdminTable>
      <div className="text-xl mt-6 font-semibold">Total: {filteredFacilities.length}</div>
    </div>
  )
}

export default Facilities
